import { render, staticRenderFns } from "./MedicalContents.vue?vue&type=template&id=7969701e&scoped=true&"
import script from "./MedicalContents.vue?vue&type=script&lang=js&"
export * from "./MedicalContents.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContents.vue?vue&type=style&index=0&id=7969701e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7969701e",
  null
  
)

export default component.exports